import React, { useState } from "react";
import { connect } from "react-redux";
import { SearchRequestGrid } from "../search-request-grid/SeachRequestGrid";
import { searchRegisterAPI } from "../../../api/searchRegisterAPI/searchRegisterAPI";
import { Aside } from "../../components";
import LoadingOverlay from "react-loading-overlay-ts";
import { PopUp } from "../../components/PopUp/PopUp.js";

const SearchContainer = (props) => {
  const [data, setDataGrid] = useState([]);
  const [isActive, setActive] = useState(false);
  const [show, setShow] = useState({ status: false, message: "" });

  const hideModal = () => {
    setShow(false);
  };

  const searchRegister = async (type, content) => {
    setActive(true);
    const response = await searchRegisterAPI.searchRegister(type, content);
    if (response.status !== 200) {
      setShow({
        status: true,
        message:
          "Si è verificato un errore durante il tentativo di aggiornare i dati",
      });
    } else {
      const newData = [...data];
      const index = newData.findIndex((v) => v.type === type);

      if (newData.length === 0) {
        newData.push({
          row: 1,
          type: type,
          sourch: content,
          message: response.data.message,
        });
      } else if (index >= 0) {
        newData[index] = {
          row: index + 1,
          type: type,
          sourch: content,
          message: response.data.message,
        };
      } else {
        newData.push({
          row: 2,
          type: type,
          sourch: content,
          message: response.data.message,
        });
      }
      setDataGrid(newData);
    }
    setActive(false);
  };

  return (
    <>
      <LoadingOverlay active={isActive} spinner text="Loading ...">
        <PopUp show={show.status} handleClose={hideModal}>
          <div
            className="row"
            style={{
              height: "30px",
              marginLeft: "0px",
              marginRight: "0px",
              backgroundColor: "#FDA443",
              borderRadius: "10px 10px 0px 0px",
            }}
          >
            {" "}
          </div>
          <p></p>
          <h2 className="row justify-content-md-center">{show.message}</h2>
        </PopUp>
        <div className="Search-page">
          <div className="row">
            <div className="col-xxl-6 Search-title">
              Verifica puntuale
              <br />
            </div>
          </div>
          <hr style={{ marginTop: "3.2em", marginBottom: "1.6em" }} />
          <div className="container border border-light">
            <div className="row justify-content-md-center">
              <div
                className="col-lg-11"
                style={{ marginTop: "3.2em", marginBottom: "1.6em" }}
              >
                <SearchRequestGrid
                  dataGrid={data}
                  searchRegister={searchRegister}
                />
              </div>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    </>
  );
};

const mapStateToProps = function(state) {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export const Search = connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchContainer);
